import {l} from "types/typescriptdefinisjoner_lederplan";
import angular, {IAttributes, IAugmentedJQuery, IScope} from "angular";
import {Kontekst} from "../tjenester/Kontekst";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";
import {Debugger} from 'debug'
import _ from "lodash";

const debug:Debugger = require('debug')('kreverTilgangsrolleBruker');

export function kreverTilgangsrolleBrukerForInjisering() {
    return [regNavn.ng.$animate, Kontekst.regNavn, kreverTilgangsrolleBruker];
}

/**
 * Attributt-direktiv som skjuler taggen dersom bruker ikke har angitt rolle.
 *
 * Dersom rolle prefikses med '!' vises taggen dersom bruker IKKE har rollen.
 *
 * Bruk: <a krever-tilgangsrolle-bruker="rollenavn">....</a>, elementet vil vises dersom kontekst.inneharTilgangsrolle("rollenavn") returnerer sann.
 */
export function kreverTilgangsrolleBruker($animate, kontekst: Kontekst): any /*IDirective */ {

    //KOPIERT FRA angualar.js
    var slice = [].slice;
    var jqLite = angular.element;

    function getBlockNodes(nodes) {
        // TODO(perf): update `nodes` instead of creating a new object?
        var node = nodes[0];
        var endNode = nodes[nodes.length - 1];
        var blockNodes;

        for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
            if (blockNodes || nodes[i] !== node) {
                if (!blockNodes) {
                    blockNodes = jqLite(slice.call(nodes, 0, i));
                }
                blockNodes.push(node);
            }
        }

        return blockNodes || nodes;
    }

    //KOPIERT FRA angualar.js (ngIfDirective)
    return {
        multiElement: true,
        transclude: 'element',
        priority: 600,
        terminal: true,
        restrict: 'A',
        $$tlb: true,
        link: function ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes, ctrl, $transclude) {
            var block, childScope, previousElements;
            const spesifikasjon = $attr['kreverTilgangsrolleBruker'];
            vis(evaluerSpek(spesifikasjon));

            function evaluerSpek(spek: string): boolean {
                debug('evaluerSpek %o', spek);

                const rolle = lesEnkeltSpek(spesifikasjon);
                var inneharTilgangsrolle = kontekst.inneharTilgangsrolle(rolle.navn);
                return inneharTilgangsrolle !== rolle.negert
            }

            function lesEnkeltSpek(spesifikasjon: string) {
                return {
                    navn: l.TilgansrollerBruker[_.trimStart(spesifikasjon, '!')],
                    negert: _.startsWith(spesifikasjon, '!')
                }
            }

            function vis(visElement: boolean) {
                debug(`krever-tilgangsrolle-bruker(${spesifikasjon}) gir ${visElement ? '' : 'ikke'} tilgang`); //Debug

                //kopiert fra ngIfDirective i angular.js
                if (visElement) {
                    if (!childScope) {
                        $transclude(function (clone, newScope) {
                            childScope = newScope;
                            clone[clone.length++] = document.createComment(' end kreverTilgangsrolleBruker');
                            // Note: We only need the first/last node of the cloned nodes.
                            // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                            // by a directive with templateUrl when its template arrives.
                            block = {
                                clone: clone
                            };
                            $animate.enter(clone, $element.parent(), $element);
                        });
                    }
                } else {
                    if (previousElements) {
                        previousElements.remove();
                        previousElements = null;
                    }
                    if (childScope) {
                        childScope.$destroy();
                        childScope = null;
                    }
                    if (block) {
                        previousElements = getBlockNodes(block.clone);
                        $animate.leave(previousElements).then(function () {
                            previousElements = null;
                        });
                        block = null;
                    }
                }

            }

        }
    };


}
